import base from './base'
import explain from './explain'
export default [
    {
      path: '/',
      redirect: { name: 'index' }
    },
    {
      path: '/sign-in',
      name: 'SignIn',
      component: require('@/components/SignIn'),
      meta: {
        requiredAuth: false
      }
    },
    {
      path: '/base',
      component: require('@/components/Base'),
      children : base
    },
    {
      path: '/explain',
      component: require('@/components/explain'),
      redirect: { name: 'explainRule' },
      children : explain
    },
    {	// 支付跳转
    	path:'/payGateWay',
    	name:'payGateWay',
    	component:require('@/page/payGateWay'),
	},
]



// WEBPACK FOOTER //
// ./src/router/routes.js